import React from 'react'
import DataCell from 'components/datatable/DataCell'

export default function DataRow(props) {
    const coltype = props.coltype
    const columns = props.columns
    const item = props.item
    const rowno = props.rowno
    const cellStyle = (col) => {
        const width = coltype[col]?.width ? coltype[col].width + "px" : "auto"
        return {
            textAlign: coltype[col].align ? coltype[col].align : "left",
            width,
            minWidth: width,
            maxWidth: width,
            verticalAlign: coltype[col].valign ? coltype[col].valign : "top",
        }
    }
    return (
        <tr>
            {columns && columns.map((col) =>
                col in coltype &&
                <td key={"cell-" + col + "-" + rowno}
                    style={cellStyle(col)}
                >

                    {col === 'no'
                        ? rowno
                        : <DataCell item={item} val={item[col]} colname={col} coltype={coltype[col]} />
                    }

                </td>
            )}
        </tr>
    )
}
